import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconLocationNotAvailable = (props: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} viewBox="0 0 10 16">
        <g clipPath="url(#clip0_3344_14330)">
            <path
                d="M4.85066 15.5002C7.25347 15.5002 9.20132 14.9993 9.20132 14.3813C9.20132 13.7634 7.25347 13.2625 4.85066 13.2625C2.44786 13.2625 0.5 13.7634 0.5 14.3813C0.5 14.9993 2.44786 15.5002 4.85066 15.5002Z"
                fill="#333333"
            />
            <path
                d="M9.03009 4.62874C9.03009 2.64066 7.82953 0.5 4.7457 0.5C1.66186 0.5 0.670898 2.69151 0.670898 4.62874C0.670898 4.66572 0.670898 4.70425 0.67244 4.74124C0.67244 4.75819 0.670898 4.7736 0.670898 4.79056C0.670898 8.0732 4.0306 12.0001 4.89056 12.0001C5.75052 12.0001 9.07324 7.79117 9.02855 4.79056C9.02855 4.77823 9.02701 4.7659 9.02701 4.75357C9.02701 4.71196 9.03009 4.67035 9.03009 4.62874ZM6.7122 5.6459C6.98344 5.91714 6.98344 6.35636 6.7122 6.62607C6.57658 6.76169 6.39935 6.8295 6.22212 6.8295C6.04488 6.8295 5.86765 6.76169 5.73203 6.62607L4.86436 5.7584L3.9967 6.62607C3.86108 6.76169 3.68384 6.8295 3.50661 6.8295C3.32938 6.8295 3.15215 6.76169 3.01653 6.62607C2.74528 6.35482 2.74528 5.9156 3.01653 5.6459L3.88419 4.77823L3.01653 3.91056C2.74528 3.63932 2.74528 3.20009 3.01653 2.93039C3.28777 2.65915 3.727 2.65915 3.9967 2.93039L4.86436 3.79806L5.73203 2.93039C6.00327 2.65915 6.4425 2.65915 6.7122 2.93039C6.98344 3.20163 6.98344 3.64086 6.7122 3.91056L5.84453 4.77823L6.7122 5.6459Z"
                fill="#333333"
            />
        </g>
        <defs>
            <clipPath id="clip0_3344_14330">
                <rect width="8.69978" height="15" fill="white" transform="translate(0.5 0.5)" />
            </clipPath>
        </defs>
    </ThemedFillSvgIcon>
);
